import { Link } from 'react-router-dom';
import './Events.css';

const events = [
  {
    img: '/img/FUNDGOSPLECONCER.jpg',
    date: 'August 2022',
    location: 'Toronto, Canada',
    title: 'Gospel Concert & Fundraiser',
    desc: 'This fund raising is for the upcoming launch of New Birth Church of Christ International. Join us for a powerful night of worship, testimonies, and community as we raise resources to impact lives around the world.',
    type: 'Fundraiser',
  },
  {
    img: '/img/newbirthlunch.jpeg',
    date: 'August 2022',
    location: 'Toronto, Canada',
    title: 'Official Launch of New Birth Organization',
    desc: 'The official launch of New Birth CCCI in Toronto, Canada — bringing together over 400 churches from across the globe for a historic moment of unity, fellowship, and dedication to the Great Commission.',
    type: 'Launch Event',
  },
];

export default function Events() {
  return (
    <>
      <div className="page-banner">
        <h1>Events</h1>
        <p>Gatherings that unite the Body of Christ</p>
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <span>/</span>
          <span>Events</span>
        </nav>
      </div>

      <section className="events-page">
        <div className="container">
          <div className="section-header-center" style={{ marginBottom: '3rem' }}>
            <p className="section-label">What's Happening</p>
            <h2 className="section-title">All <span>Events</span></h2>
          </div>

          <div className="events-list">
            {events.map(({ img, date, location, title, desc, type }, i) => (
              <div key={i} className="event-detail-card">
                <div className="edc-img">
                  <img src={img} alt={title} />
                  <div className="edc-type-badge">{type}</div>
                </div>
                <div className="edc-body">
                  <div className="edc-meta">
                    <span>📅 {date}</span>
                    <span>📍 {location}</span>
                  </div>
                  <h2 className="edc-title">{title}</h2>
                  <p>{desc}</p>
                  <div className="edc-actions">
                    <a
                      href="https://www.paypal.com/donate"
                      className="btn-primary-gold"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Support This Event
                    </a>
                    <Link to="/contact" style={{ color: 'var(--gold)', fontWeight: '600', fontSize: '0.88rem' }}>
                      Contact for Details →
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stay Connected Banner */}
      <section className="events-newsletter">
        <div className="container" style={{ textAlign: 'center' }}>
          <p className="section-label">Stay Connected</p>
          <h2 className="section-title">Never Miss an <span>Event</span></h2>
          <p style={{ color: '#666', maxWidth: '520px', margin: '0 auto 2rem', lineHeight: '1.8' }}>
            Sign up with your email to receive updates on upcoming events, outreaches, and ministry news
            from New Birth CCCI.
          </p>
          <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
            <input type="email" placeholder="Enter your email address" required />
            <button type="submit" className="btn-primary-gold">Subscribe</button>
          </form>
        </div>
      </section>
    </>
  );
}
